

import { getPageTitle } from '~/assets/js/seo/title.js';
import { mapState, mapGetters } from 'vuex'
import projectsStatic from '~/static/db/projects.json';
const environment = process.env.NODE_ENV || 'production';
const envSet = require(`~/api/env.${environment}.js`)


export default {

	data() {

		var current = null;
		var index = 0;
		var prev = null;
		var next = null;

		//===
		for (var i = 0; i < this.$store.getters.projects.length; i++) {
			if (this.$store.getters.projects[i].slug === this.$route.params.slug) {
				current = this.$store.getters.projects[i];
				index = i;
			}
		}

		//===
		var next = index < this.$store.getters.projects.length - 1 ? this.$store.getters.projects[index + 1] : this.$store.getters.projects[0];
		var prev = index === 0 ? this.$store.getters.projects[ this.$store.getters.projects.length - 1 ] : this.$store.getters.projects[ index - 1 ];

		//===
		return {
			current : current,
			prev    : prev,
			next    : next,
		};

	},

	computed: {
		...mapGetters([
			'projects'
		]),
	},


	head() {
		var _current = null;
		var _currentStatic = null;
		for (var i = 0; i < this.$store.getters.projects.length; i++) {
			if (this.$store.getters.projects[i].slug === this.$route.params.slug) {
				_current = this.$store.getters.projects[i];
			}
		}
		for (var n = 0; n < projectsStatic.length; n++) {
			if (projectsStatic[n].slug === this.$route.params.slug) {
				_currentStatic = projectsStatic[n];
			}
		}
		if( _current && _currentStatic ){
			_current = Object.assign({}, _current, _currentStatic);
		}

		if( _current ){
			let _title = getPageTitle(this.$i18n.locale, _current.title);
			let _description = _current.description;
			let _image = _current.ogp ? envSet.globalUrl + _current.ogp : envSet.globalUrl + '/assets/img/ogp.png';
			return {
				title: _title,
				htmlAttrs: {
					lang: this.$i18n.locale,
				},
				meta: [
					{
						name: "description",
						content: _description,
					},
					{ hid: 'og:image', property: 'og:image', content: _image },
					{ hid: 'twitter:image:src', name: 'twitter:image:src', content: _image },
					{ hid: 'twitter:image', name: 'twitter:image', content: _image }
				],
			}
		} else {
			return {
				title: getPageTitle(this.$i18n.locale, '404')
			}
		}

	},

	async fetch ({ store, $http }) {
		if( !store.getters.projects.length ){
			const request = `${envSet.staticUrl}/db/projects.json`;
			const response = await $http.$get( request );
			store.dispatch( 'setProjects', response );
		}
	},

	async asyncData({ params, $http, error }) {
		let request = `${envSet.staticUrl}/db/db-projects/${params.slug}.json`;
		return await $http.$get( request )
		.then((res) => {
			return { current_post: res }
		})
		.catch((e) => {
			error({ statusCode: 404, message: 'Post not found' })
		});
	},


	// head() {
	// 	let _title = 'Kenta Toshikura | ' + this.current.data.post.title;
	// 	let _description = this.current.data.post.description;
	// 	return {
	// 		title: _title,
	// 		meta: [
	// 			{
	// 				name: 'description',
	// 				content: _description,
	// 			},
	// 			{ hid: 'og:title', property: 'og:title', content: _title },
	// 			{ hid: 'og:description', property: 'og:description', content: _description }
	// 		]
	// 	}
	// },

	mounted() {

		//
		ROUTE.onMounted( this.$store.$device, {
			current : { type : 'single', slug : this.$route.params.slug },
			prev    : null,
			next    : null
		});

		//
		this.$nextTick(function() {
			const $count = this.$el.querySelectorAll('.js-count');
			for (var i = 0; i < $count.length; i++) {
				$count[i].innerText = (i+1) + '.';
			}
		});

		// this.$nextTick(function() {
		// 	console.log( this );
		// 	console.log('-----------------------------------');
		// 	console.log('nextTick');
		// 	ROUTE.onNextTick( this );
		// });
		// if( process.browser ){
		// 	console.log('-----------------------------------');
		// 	console.log( process.browser );
		// }

		// ROUTE.onMounted( 'archive', this.$store.$device, {
		// 	current : 'archive',
		// 	prev : null,
		// 	next : null
		// });

	},

	transition : {
		mode: 'out-in',
		css: false,
		beforeEnter( el ){
			ROUTE.beforeEnter( el );
		},
		enter( el, done ){
			ROUTE.enter( el, done );
		},
		afterEnter( el ){
			ROUTE.afterEnter( el );
		},
		leave( el, done ){
			ROUTE.leave(el, done);
		},
	}

}
